// import React from "react";
// import LeftSidebar from "./Sidebar";
// import QnexusHeader from "./Header";


// const MainLayout = ({ children }) => {
//     return (
//         <div className="qnexus-layout">
//             <LeftSidebar />
//             <div className="qnexus-main">
//                 <QnexusHeader />
//                 {children}
//             </div>
//         </div>
//     );
// };

// export default MainLayout;


import React, { useState } from "react";
import LeftSidebar from "./Sidebar";
import QnexusHeader from "./Header";

const MainLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="qnexus-layout">

            {/* SIDEBAR */}
            <LeftSidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
            />

            {/* MAIN AREA */}
            <div className="qnexus-main">
                <QnexusHeader onMenuClick={() => setSidebarOpen(true)} />
                {children}
            </div>

        </div>
    );
};

export default MainLayout;
